import React, { useEffect, lazy } from 'react';
import { Button } from '../components/ui/Button';
import { ArrowRight, ShieldCheck, Lock } from 'lucide-react';
import { useSpotCountdown } from '../hooks/useSpotCountdown';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { useDeadlineCountdown } from '../hooks/useDeadlineCountdown';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { FloatingCta } from '../components/FloatingCta';
export function CheckoutPage() {
  const {
    spots
  } = useSpotCountdown();
  const {
    trackCustomEvent
  } = useMetaPixel();
  const countdown = useDeadlineCountdown();
  const ACTIVE_CHECKOUT_URL = 'https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5';
  useEffect(() => {
    trackCustomEvent('Checkout-Page-Vist');
  }, [trackCustomEvent]);
  const handleCheckout = () => {
    trackCustomEvent('Initiate-Checkout-97');
    window.location.href = ACTIVE_CHECKOUT_URL;
  };
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="min-h-screen w-full flex flex-col items-center bg-[#FAFAFA] px-4 py-6 sm:py-10" data-id="element-371" data-mp="13rbwh9ysimov">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-372" data-mp="yrfufg9nl5by">
        <div className="p-5 sm:p-8 space-y-5" data-id="element-373" data-mp="trl4bexpcjry">
          {/* Header — compact, above the fold */}
          <div className="text-center space-y-1.5" data-id="element-374" data-mp="ppzkf9mr3589">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-375" data-mp="ptdk2a4150c0">
              48 HRS AI CASH MACHINE
            </h1>
            <p className="text-gray-500 text-sm sm:text-base" data-id="element-376" data-mp="g06kx6zvugkd">
              Acceso Completo al Programa
            </p>
          </div>

          {/* Spots urgency pill */}
          {!countdown.isExpired && <div className={`text-center text-xs sm:text-sm font-bold uppercase tracking-wider py-2 px-3 rounded-lg transition-colors duration-300 ${spots === 1 ? 'text-red-700 bg-red-50 border border-red-200 animate-flash' : 'text-emerald-700 bg-emerald-50 border border-emerald-200'}`} data-id="element-377" data-mp="6437v63hsxin">
              🔥 Solo {spots}{' '}
              {spots === 1 ? 'Cupo Disponible' : 'Cupos Disponibles'}
            </div>}

          {/* Price block */}
          <div className="text-center py-1" data-id="element-378" data-mp="3njmmmxu7wbc5">
            <div className="text-[11px] sm:text-xs uppercase tracking-wider text-gray-500 font-semibold mb-1" data-id="element-379" data-mp="39mra2verc1rc">
              {countdown.isExpired ? 'Precio Regular' : 'Precio Especial Hoy'}
            </div>
            <div className="flex items-baseline justify-center gap-3" data-id="element-380" data-mp="66af8xzk9rba">
              <span className="text-5xl sm:text-6xl font-bold text-gray-900 tracking-tight tabular-nums" data-id="element-381" data-mp="b42jmrhe75wd">
                {countdown.isExpired ? '$1997' : '$497'}
              </span>
              {!countdown.isExpired && <span className="text-lg sm:text-xl text-gray-400 line-through tabular-nums" data-id="element-382" data-mp="1dzejswzy1ho">
                  $1997
                </span>}
            </div>
          </div>

          {/* PRIMARY CTA — above the fold on mobile */}
          {!countdown.isExpired ? <div className="space-y-3" data-id="element-383" data-mp="tw4u1l3fxpy6">
              <Button onClick={handleCheckout} size="lg" className="w-full text-base sm:text-lg font-bold h-16 sm:h-[68px] shadow-lg shadow-emerald-600/20 ring-1 ring-emerald-500/30" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-385" data-mp="2ndj5n89zt7r1" />} data-id="element-384" data-mp="2ekpb63lz61sl">
                Comprar Ahora
              </Button>
              <div className="flex items-center justify-center gap-4 text-[11px] sm:text-xs text-gray-500" data-id="element-386" data-mp="2jbxjsxfhdj4p">
                <span className="flex items-center gap-1" data-id="element-387" data-mp="1vm384j6we0m1">
                  <Lock className="w-3 h-3" data-id="element-388" data-mp="1vmmrm4c74x26" />
                  Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-389" data-mp="1qp4es2v25xow">
                  <ShieldCheck className="w-3 h-3" data-id="element-390" data-mp="24nb4uwtrmte0" />
                  Garantía 30 días
                </span>
              </div>
            </div> : <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 space-y-2 text-center" data-id="element-391" data-mp="1zmn4hkjnd074">
              <p className="text-base font-semibold text-gray-900" data-id="element-392" data-mp="3g0ddn5pmienm">
                La oferta especial ha terminado
              </p>
              <p className="text-sm text-gray-600" data-id="element-393" data-mp="a85o9wkg6p5y">
                Contáctanos por WhatsApp para conocer las opciones disponibles.
              </p>
            </div>}

          {/* Countdown — urgency reinforcer below CTA */}
          {!countdown.isExpired && <div className="bg-red-600 rounded-xl p-3.5 space-y-2" data-id="element-394" data-mp="k4ihyufzt30p">
              <p className="text-[10px] sm:text-xs uppercase tracking-wider text-red-100 font-semibold text-center" data-id="element-395" data-mp="p5g9hxmw79ev">
                ⏳ El precio sube a $1997 el viernes en
              </p>
              <div className="flex justify-center items-baseline gap-1.5 sm:gap-3" data-id="element-396" data-mp="y5cqdd31j3zd">
                {countdown.days > 0 && <>
                    <div className="flex flex-col items-center min-w-0 flex-1 max-w-[60px]" data-id="element-397" data-mp="12xw4cb5n414p">
                      <span className="text-xl sm:text-2xl font-bold text-white tabular-nums" data-id="element-398" data-mp="17ucsv6gr4hib">
                        {pad(countdown.days)}
                      </span>
                      <span className="text-[9px] sm:text-[10px] uppercase text-red-200" data-id="element-399" data-mp="1gvuh5c4bbpi3">
                        Días
                      </span>
                    </div>
                    <span className="text-xl sm:text-2xl font-bold text-red-300" data-id="element-400" data-mp="31c22hyieyi4i">
                      :
                    </span>
                  </>}
                <div className="flex flex-col items-center min-w-0 flex-1 max-w-[60px]" data-id="element-401" data-mp="2serrme9icv04">
                  <span className="text-xl sm:text-2xl font-bold text-white tabular-nums" data-id="element-402" data-mp="2nfngvj6xqp7o">
                    {pad(countdown.hours)}
                  </span>
                  <span className="text-[9px] sm:text-[10px] uppercase text-red-200" data-id="element-403" data-mp="3g3ax6m16atoi">
                    Hrs
                  </span>
                </div>
                <span className="text-xl sm:text-2xl font-bold text-red-300" data-id="element-404" data-mp="3bb9n96rh9f1n">
                  :
                </span>
                <div className="flex flex-col items-center min-w-0 flex-1 max-w-[60px]" data-id="element-405" data-mp="36d7x61vmwfgo">
                  <span className="text-xl sm:text-2xl font-bold text-white tabular-nums" data-id="element-406" data-mp="7osjo4sgqlxi">
                    {pad(countdown.minutes)}
                  </span>
                  <span className="text-[9px] sm:text-[10px] uppercase text-red-200" data-id="element-407" data-mp="1x4cz9wzrlnwj">
                    Min
                  </span>
                </div>
                <span className="text-xl sm:text-2xl font-bold text-red-300" data-id="element-408" data-mp="218b2ojw4hkve">
                  :
                </span>
                <div className="flex flex-col items-center min-w-0 flex-1 max-w-[60px]" data-id="element-409" data-mp="1sdmvupawfv4h">
                  <span className="text-xl sm:text-2xl font-bold text-white tabular-nums" data-id="element-410" data-mp="1dgm10cxevk1s">
                    {pad(countdown.seconds)}
                  </span>
                  <span className="text-[9px] sm:text-[10px] uppercase text-red-200" data-id="element-411" data-mp="1iha1rqbfzf97">
                    Seg
                  </span>
                </div>
              </div>
            </div>}

          {/* Hero image — moved below CTA, lazy-loaded */}
          <img src="https://cdn.magicpatterns.com/uploads/itJEPFUgjYgyD9nVnBFzm6/Screenshot_2026-06-04_at_6.19.19_PM.png" alt="48 Hrs AI Cash Machine - Sistema completo" loading="lazy" decoding="async" className="w-full h-auto rounded-xl" data-id="element-412" data-mp="2yu8e5xc34pxu" />

          {/* Secondary CTA after image */}
          {!countdown.isExpired && <Button onClick={handleCheckout} size="lg" className="w-full text-base sm:text-lg font-semibold h-14 sm:h-16" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-414" data-mp="3mq3mrp99xmlw" />} data-id="element-413" data-mp="38yf93hjdmq2t">
              Comprar Ahora
            </Button>}

          <p className="text-[11px] sm:text-xs text-gray-400 text-center pt-1" data-id="element-415" data-mp="3hxisynqdb9id">
            Serás redirigido a nuestra página de pago segura.
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-6 mb-24 text-center text-gray-400 text-xs sm:text-sm px-4" data-id="element-416" data-mp="3rnll6lpo0jfn">
        &copy; {new Date().getFullYear()} AI Web Closer. Todos los derechos
        reservados.
      </div>

      {/* Sticky floating CTA — always-accessible buy button */}
      {!countdown.isExpired && <FloatingCta onClick={handleCheckout} price="$497" originalPrice="$1997" label="COMPRAR" showAfter={400} data-id="element-417" data-mp="2b9ddtydgugol" />}

      <FloatingWhatsApp link="https://wa.link/infocommerce" data-id="element-418" data-mp="279v1vs3mhfxw" />
    </div>;
}